<template>
	<v-divider :class="dividerClasses"></v-divider>
</template>

<script>
export default {
	name: 'FormDivider',
	props: {
		inner: Boolean,
		mb: {
			type: [Number, String],
			default: 8
		},
		mt: {
			type: [Number, String],
			default: 4
		},
		my: [Number, String]
	},
	computed: {
		dividerClasses() {
			const { inner, mb, mt, my } = this;
			const myClass = my ? `my-${my}` : `mb-${mb} mt-${mt}`;
			const opacityClass = inner ? 'opacity-80' : 'opacity-50';
			return [myClass, opacityClass];
		}
	}
}

/*
	The FormDivder component is used below FormTitle components and between form sections 
	which are typically separated by <v-form> or <ui-box> components. 
 */
</script>